import { basePath } from 'src/env';

export const RoutePaths = {
    index: `${basePath}/`,

    partners: `${basePath}/partners`,
    partnersDetails: `${basePath}/partners/:id`,
    partnersEdit: `${basePath}/partners/:id/edit`,
    partnersCreate: `${basePath}/partners/create`,

    merchants: `${basePath}/merchants`,
    merchantDetails: `${basePath}/merchants/:id`,

    loanApplications: `${basePath}/loan-applications`,
    loanApplicationDetails: `${basePath}/loan-applications/:id`,

    transactions: `${basePath}/transactions`,
};
